import { render, staticRenderFns } from "./PageSize.vue?vue&type=template&id=391b6854"
import script from "./PageSize.vue?vue&type=script&lang=js"
export * from "./PageSize.vue?vue&type=script&lang=js"
import style0 from "./PageSize.vue?vue&type=style&index=0&id=391b6854&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports